import { motion } from "framer-motion";

// Indicador de Aforo — presentacional puro.
export const AforoIndicator = ({ aforo, lleno }) => (
  <div className="px-5 lg:px-8 py-5 border-b border-white/10">
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
      className={`flex items-center justify-between p-5 border ${lleno ? "bg-[#EF4444] border-[#EF4444]" : "bg-white/5 border-white/15"}`} data-testid="aforo-indicator">
      <div>
        <p className={`text-[10px] tracking-[0.2em] uppercase font-bold ${lleno ? "text-white/80" : "text-white/50"}`}>Aforo · Disponibles</p>
        {aforo?.capacidad_total == null ? (
          <p className="font-display text-2xl font-black mt-1 text-white/60">Sin capacidad configurada</p>
        ) : lleno ? (
          <p className="font-display text-5xl font-black mt-1 tracking-tight" data-testid="aforo-lleno">LLENO</p>
        ) : (
          <p className="font-display text-5xl font-black mt-1 tracking-tight text-[#FFCC00]" data-testid="aforo-disponibles">
            {aforo?.disponibles}<span className="text-white/40 text-2xl"> / {aforo?.capacidad_total}</span>
          </p>
        )}
      </div>
      <div className="text-right">
        <p className="text-[10px] tracking-[0.2em] uppercase font-bold text-white/50">Activos</p>
        <p className="font-display text-3xl font-black">{aforo?.activos ?? 0}</p>
      </div>
    </motion.div>
  </div>
);

export default AforoIndicator;
